export const GOOGLE_CLIENT_ID =
  "127841552352-h0v9610ift21us4flnc4tdsi2nmtoi7h.apps.googleusercontent.com";
